export default __webpack_public_path__ + "static/hero-019a64e0a671a71b7cb6b81684273597.svg";